export default {
  solution: 'Giới thiệu giải pháp ORBRO',
  product: 'Sản phẩm liên quan',

  helmet: '',
  desc: '',
  keywords: '',

  ogTitle: '',
  ogSite: '',
  ogDesc: '',
  ogUrl: 'https://orbro.io/vi/blog',
  ogType: '',

  twitterCard: '',
  twitterTitle: '',
  twitterDesc: '',

  title: '<strong>ORBRO</strong> Blog',
  description: 'Đọc công nghệ và tin tức mới nhất từ ORBRO.',
  blogList: [
     {
 name: 'blogDientoanDammay',
 date: '2025-07-10',
 label: 'Điện toán đám mây là gì? Lợi ích và ứng dụng thực tế',
 path: '/vi/blog/dien-toan-dam-may-la-gi',
},
     {
 name: 'blogCameraThongminh',
 date: '2025-07-10',
 label: 'Camera thông minh là gì? Lợi ích và ứng dụng trong cuộc sống',
 path: '/vi/blog/camera-thong-minh-la-gi',
},
    {
 name: 'blogBigData',
 date: '2025-07-10',
 label: 'Big Data là gì? Ứng dụng của Big Data trong chuyển đổi số doanh nghiệp',
 path: '/vi/blog/big-data-la-gi',
},
     {
 name: 'blogTrituenhantao',
 date: '2025-07-10',
 label: 'Trí tuệ nhân tạo là gì? Lợi ích và ứng dụng của AI',
 path: '/vi/blog/tri-tue-nhan-tao-la-gi',
},
     {
 name: 'blogBeaconlagi',
 date: '2025-07-09',
 label: 'Beacon là gì? Công nghệ định vị đột phá trong kỷ nguyên số',
 path: '/vi/blog/beacon-la-gi',
},
    {
 name: 'blogVanphongthongminh',
 date: '2025-07-09',
 label: 'Văn phòng thông minh là gì? Khám phá không gian làm việc tương lai',
 path: '/vi/blog/van-phong-thong-minh-la-gi',
},
     {
 name: 'blogMachineLearning',
 date: '2025-07-09',
 label: 'Machine Learning là gì? Khám phá công nghệ đột phá đang thay đổi thế giới',
 path: '/vi/blog/machine-learning-la-gi',
},
     {
 name: 'blogNvrlagi',
 date: '2025-07-09',
 label: 'NVR là gì? Ưu điểm của NVR trong hệ thống Camera giám sát',
 path: '/vi/blog/nvr-la-gi',
},
     {
 name: 'blogAiotlagi',
 date: '2025-07-08',
 label: 'AIoT là gì? Khái niệm, ứng dụng và phân loại',
 path: '/vi/blog/aiot-la-gi-khai-niem-ung-dung-va-phan-loai',
},
     {
 name: 'blogCctv',
 date: '2025-07-08',
 label: 'CCTV là gì? Phân loại và vai trò trong kỷ nguyên số',
 path: '/vi/blog/cctv-la-gi-phan-loai-va-vai-tro',
},
    {
 name: 'blogGeofencinglagi',
 date: '2025-07-08',
 label: 'Geofencing là gì? Có thể mang lại lợi ích gì cho doanh nghiệp?',
 path: '/vi/blog/geofencing-la-gi',
},
     {
 name: 'blogUwblagi',
 date: '2025-07-08',
 label: 'UWB là gì? Công dụng và nguyên lý hoạt động',
 path: '/vi/blog/uwb-la-gi',
},
    {
 name: 'blogChuoicungung',
 date: '2025-07-08',
 label: 'Logistics và Quản lý chuỗi cung ứng là gì?',
 path: '/vi/blog/logistics-va-quan-ly-chuoi-cung-ung-la-gi',
},
     {
 name: 'blogDigitaltwinlagi',
 date: '2025-07-07',
 label: 'Digital Twin là gì? Ứng dụng gì trong đời sống?',
 path: '/vi/blog/digital-twin-la-gi-ung-dung-gi-trong-doi-song',
},
     {
 name: 'blogAicameralagi',
 date: '2025-07-07',
 label: 'AI Camera là gì? Có tác dụng gì trong cuộc sống hiện đại?',
 path: '/vi/blog/ai-camera-la-gi-co-tac-dung-gi-trong-cuoc-song-hien-dai',
},
     {
 name: 'blogIpslagi',
 date: '2025-07-07',
 label: 'IPS (Định vị trong nhà) là gì? Vai trò của IPS trong công nghệ?',
 path: '/vi/blog/ips-dinh-vi-trong-nha-la-gi',
},
     {
 name: 'blogThanhpho',
 date: '2025-07-07',
 label: 'Smart City (Thành phố thông minh) là gì?',
 path: '/vi/blog/smart-city-thanh-pho-thong-minh-la-gi',
},
     {
 name: 'blogAntoanlaodong',
 date: '2025-07-07',
 label: 'An toàn lao động là gì? Các biện pháp đảm bảo an toàn lao động?',
 path: '/vi/blog/smart-city-thanh-pho-thong-minh-la-gi',
},
    {
 name: 'blogAntoanlaodong',
 date: '2025-07-07',
 label: 'An toàn lao động là gì? Các biện pháp đảm bảo an toàn lao động?',
 path: '/vi/blog/an-toan-lao-dong-la-gi',
},
    {
      name: 'blogGpstracking',
      date: '2025-07-04',
      label: 'GPS Tracking là gì?',
      path: '/vi/blog/gps-tracking-la-gi',
    },
    {
      name: 'blogGiamsat',
      date: '2025-07-04',
      label: 'Camera giám sát là gì? Có những loại nào?',
      path: '/vi/blog/camera-giam-sat-la-gi-co-nhung-loai-nao',
    },
    {
      name: 'blogVanphong',
      date: '2025-07-04',
      label: 'Smart Office là gì?',
      path: '/vi/blog/smart-office-la-gi',
    },
    {
      name: 'blogCambien',
      date: '2025-07-04',
      label: 'Cảm biến thông minh là gì? Có những loại cảm biến thông minh nào?',
      path: '/vi/blog/cam-bien-thong-minh-la-gi-co-nhung-loai-cam-bien-thong-minh-nao',
    },

    {
      name: 'blogXemay',
      date: '2025-07-04',
      label: 'Định vị xe máy là gì? Ứng dụng của định vị GPS vào định vị xe máy',
      path: '/vi/blog/dinh-vi-xe-may-la-gi',
    },
    {
      name: 'blogNhamay',
      date: '2025-07-04',
      label: 'Nhà máy thông minh (Smart Factory) là gì?',
      path: '/vi/blog/nha-may-thong-minh-smart-factory-la-gi',
    },
    {
      name: 'blogLogisticsthongminh',
      date: '2025-07-03',
      label: 'Smart Logistics là gì? Ứng dụng hữu ích cho doanh nghiệp',
      path: '/vi/blog/smart-logistics-la-gi',
    },
    {
      name: 'blogPhanmemquanlykho',
      date: '2025-07-03',
      label: 'Phần mềm quản lý kho theo vị trí là gì? Ứng dụng trong logistics',
      path: '/vi/blog/phan-mem-quan-ly-kho-theo-vi-tri-la-gi',
    },
    {
      name: 'blogGiaothongthongminh',
      date: '2025-07-03',
      label: 'Hệ thống giao thông thông minh là gì?',
      path: '/vi/blog/he-thong-giao-thong-minh-la-gi',
    },
    {
      name: 'blogAiLaGi',
      date: '2025-07-03',
      label: 'Công nghệ AI là gì? Ứng dụng AI trong định vị vị trí',
      path: '/vi/blog/cong-nghe-ai-la-gi',
    },

    {
      name: 'blogIotLaGi',
      date: '2025-07-03',
      label: 'IoT là gì? Ứng dụng của IoT?',
      path: '/vi/blog/iot-la-gi',
    },

    {
      name: 'blogLoraLaGi',
      date: '2025-07-03',
      label: 'Lora là gì?',
      path: '/vi/blog/lora-la-gi',
    },

    {
      name: 'blogSmartWareHouse',
      date: '2025-06-26',
      label: 'Nhà kho thông minh là gì?',
      path: '/vi/blog/smartwarehouse',
    },
    {
      name: 'blogUseCaseOfIoT',
      date: '2025-06-23',
      label: 'IoT là gì? Ứng dụng của IoT',
      path: '/vi/blog/usecase-of-iot',
    },
    {
      name: 'blogTechnologyOfLora',
      date: '2025-06-18',
      label: 'Công nghệ LoRa là gì? Ứng dụng của LoRa',
      path: '/vi/blog/technology-of-lora',
    },
    {
      name: 'blogEnterpriseSolution',
      date: '2025-06-16',
      label: 'Định vị vị trí và an ninh: Giải pháp cho doanh nghiệp',
      path: '/vi/blog/enterpriseSolution',
    },
    {
      name: 'blogWhatIsRfid',
      date: '2025-06-11',
      label: 'RFID là gì? Nguyên lý hoạt động và ứng dụng',
      path: '/vi/blog/whatisrfid',
    },
    {
      name: 'blogCarTracking',
      date: '2025-06-09',
      label: 'Định vị xe ô tô với thiết bị định vị thời gian thực (RTLS)',
      path: '/vi/blog/carTracking',
    },
    {
      name: 'blogSmartShipyard',
      date: '2024-05-09',
      label: 'Giải pháp Smart Shipyard',
      path: '/vi/blog/smart-shipyard',
    },
    {
      name: 'blogAIoT',
      date: '2024-05-09',
      label: 'AIoT là gì? | Định nghĩa, Công nghệ, Ứng dụng và Ưu điểm',
      path: '/vi/blog/what-is-aiot',
    },
    {
      name: 'blogAiCamera',
      date: '2024-02-07',
      label: 'Giải pháp định vị vị trí bằng AI Camera',
      path: '/vi/blog/ai-camera',
    },
    {
      name: 'blogIndoorGPS',
      date: '2024-01-31',
      label: 'Giải pháp, ứng dụng GPS trong nhà',
      path: '/vi/blog/indoor-gps',
    },
    {
      name: 'blogSmartBuildings',
      date: '2024-01-30',
      label: 'Smart Building là gì?',
      path: '/vi/blog/smart-buildings',
    },
    {
      name: 'blogSmartPort',
      date: '2024-01-25',
      label: 'Giải pháp, Ứng dụng Smart Port (Cảng thông minh)',
      path: '/vi/blog/smart-port',
    },
    {
      name: 'blogSmartParking',
      date: '2024-01-24',
      label: 'Hệ thống Bãi giữ xe thông minh (Smart Parking)',
      path: '/vi/blog/smart-parking',
    },
    {
      name: 'blogIPS',
      date: '2024-01-23',
      label: 'IPS(Indoor Positioning System) là gì?',
      path: '/vi/blog/indoor-positioning-system',
    },
    {
      name: 'blogSmartAirport',
      date: '2024-01-16',
      label: 'Giải pháp Smart Airport',
      path: '/vi/blog/smart-airport-solution',
    },
    {
      name: 'blogSmartHospital',
      date: '2024-01-16',
      label: 'Smart Hospital là gì?',
      path: '/vi/blog/what-is-a-smart-hospital',
    },
    {
      name: 'blogLoRA',
      date: '2024-01-15',
      label: 'LoRA là gì?',
      path: '/vi/blog/what-is-LoRA',
    },
    {
      name: 'blogSmartFactory2',
      date: '2024-01-12',
      label: 'Smart Factory là gì?',
      path: '/vi/blog/what-is-a-smart-factory',
    },
    {
      name: 'blogNVR',
      date: '2024-01-12',
      label: 'NVR là gì?',
      path: '/vi/blog/nvr',
    },
    {
      name: 'blogNFC',
      date: '2024-01-11',
      label: 'NFC là gì?',
      path: '/vi/blog/nfc',
    },
    {
      name: 'blogRFID',
      date: '2024-01-11',
      label: 'RFID là gì?',
      path: '/vi/blog/rfid',
    },
    {
      name: 'blogWhatIsDX',
      date: '2024-01-10',
      label: 'Chuyển đổi số (Digital Transformation) là gì?',
      path: '/vi/blog/what-is-digital-transformation',
    },
    {
      name: 'blogContainerTracking',
      date: '2024-01-09',
      label: 'Container Tracking',
      path: '/vi/blog/container-tracking',
    },
    {
      name: 'blogExampleOfSmartCity',
      date: '2024-01-09',
      label: 'Các trường hợp ứng dụng triển khai Smart City (Smart City)',
      path: '/vi/blog/example-of-smart-city',
    },
    {
      name: 'blogWhatIsSmartCity',
      date: '2024-01-08',
      label: 'Thành phố thông minh (Smart City) là gì?',
      path: '/vi/blog/what-is-smart-city',
    },
    {
      name: 'blogBLE',
      date: '2024-01-04',
      label: 'BLE là gì? | Bluetooth Low Energy',
      path: '/vi/blog/ble',
    },
    {
      name: 'blogDigitalTwin3',
      date: '2023-12-28',
      label: 'Digital Twin là gì? | Định nghĩa, và các trường hợp ứng dụng',
      path: '/vi/blog/digital-twin',
    },
    {
      name: 'blogDigitalTwinDigitalCity',
      date: '2023-12-26',
      label: 'Digital Twin (8) - Xây dựng thành phố với đồ họa sống động',
      path: '/vi/blog/digitaltwin-digitalcity',
    },
    {
      name: 'blogDigitalTwinCCTV',
      date: '2023-12-26',
      label: 'Digital Twin (7) - Kết nối CCTV giao thông',
      path: '/vi/blog/digitaltwin-cctv',
    },
    {
      name: 'blogDigitalTwinAirplane',
      date: '2023-12-26',
      label: 'Digital Twin (6) - Kết nối thông tin máy bay',
      path: '/vi/blog/digitaltwin-airplane',
    },
    {
      name: 'blogDigitalTwinTraffic',
      date: '2023-12-26',
      label: 'Digital Twin (5) - Kết nối thông tin Xe buýt và Tàu điện ngầm',
      path: '/vi/blog/digitaltwin-traffic',
    },
    {
      name: 'blogDigitalTwinTracking',
      date: '2023-12-26',
      label: 'Digital Twin (4) - Kết nối chuyển động thời gian thực của người và phương tiện',
      path: '/vi/blog/digitaltwin-tracking',
    },
    {
      name: 'blogDigitalTwinBuildings',
      date: '2023-12-26',
      label: 'Digital Twin (3) - Xây dựng thông tin tòa nhà và thông tin trong nhà',
      path: '/vi/blog/digitaltwin-buildings',
    },
    {
      name: 'blogDigitalTwinWeather',
      date: '2023-12-26',
      label: 'Digital Twin (2) - Xây dựng thông tin khí quyển và khí tượng',
      path: '/vi/blog/digitaltwin-weather',
    },
    {
      name: 'blogDigitalTwinGis',
      date: '2023-12-26',
      label: 'Digital Twin (1) - Xây dựng Thông tin địa lý GIS',
      path: '/vi/blog/digitaltwin-gis',
    },
    {
      name: 'blogQaUwb',
      date: '2023-12-18',
      label: 'UWB: Giải pháp cho quản lý chất lượng và quản lý hàng tồn kho',
      path: '/vi/blog/qa-uwb',
    },
    {
      name: 'blogConstructionSolution',
      date: '2023-12-11',
      label: 'Giải pháp phòng ngừa theo Luật Xử phạt Tai nạn Nghiêm trọng: Quản lý an toàn công trường xây dựng (luật Hàn Quốc)',
      path: '/vi/blog/construction-solution',
    },
    {
      name: 'blogRfidRtls',
      date: '2023-11-28',
      label: 'RTLS - giải pháp thay thế RFID',
      path: '/vi/blog/rfid-rtls',
    },
    {
      name: 'blogNfcUwbBle',
      date: '2023-11-20',
      label: 'Quản lý kho hàng bằng UWB và BLE – Giải pháp thay thế cho thẻ NFC',
      path: '/vi/blog/nfc-uwb-ble',
    },
    {
      name: 'blogRtlsCompany',
      date: '2023-11-15',
      label: 'Các tiêu chí quan trọng để chọn nhà cung cấp RTLS',
      path: '/vi/blog/rtlsCompany',
    },
    {
      name: 'blogRfidNfcUwb',
      date: '2023-11-10',
      label: 'RFID, NFC, UWB: Nên chọn công nghệ nào?',
      path: '/vi/blog/RfidNfcUwb',
    },
    {
      name: 'blogBeacon',
      date: '2023-11-08',
      label: 'Beacon là gì?',
      path: '/vi/blog/beacon',
    },
    {
      name: 'blogProductionAutomation',
      date: '2023-11-06',
      label: 'Giải pháp cho nhà máy thông minh và tự động hóa sản xuất',
      path: '/vi/blog/productionAutomation',
    },
    {
      name: 'blogUwbRtls',
      date: '2023-11-03',
      label: 'UWB RTLS, sự khởi đầu cho các ngành công nghiệp của tương lai',
      path: '/vi/blog/uwbRtls',
    },
    {
      name: 'blogRtlsHealthcare',
      date: '2023-11-02',
      label: 'RTLS trong lĩnh vực chăm sóc sức khỏe, có thể ứng dụng ngay',
      path: '/vi/blog/rtlsHealthcare',
    },
    {
      name: 'blogDX',
      date: '2023-11-01',
      label: 'Chuyển đổi số (DX) là gì?',
      path: '/vi/blog/dx',
    },
    {
      name: 'blogOfficeSolution',
      date: '2023-10-31',
      label: 'Giải pháp xây dựng văn phòng thông minh',
      path: '/vi/blog/officeSolution',
    },
    {
      name: 'blogDigitalTwin2',
      date: '2023-10-26',
      label: 'Digital Twin: Tìm hiểu bản chất và triển vọng phát triển',
      path: '/vi/blog/digitalTwin2',
    },
    {
      name: 'blogNextManufacturing',
      date: '2023-10-16',
      label: 'Tương lai của hệ thống quản lý hàng tồn kho trong nhà máy sản xuất',
      path: '/vi/blog/nextManufacturing',
    },
    {
      name: 'blogSmartFactory',
      date: '2023-10-12',
      label: 'Cách nhà máy thông minh đang thay đổi ngành công nghiệp sản xuất',
      path: '/vi/blog/smartFactory',
    },
    {
      name: 'blogSmartSafety',
      date: '2023-10-04',
      label: 'Giải pháp quản lý an toàn thông minh toàn diện chỉ trong một',
      path: '/vi/blog/smartSafety',
    },
    {
      name: 'blogHeavyEquipment',
      date: '2023-09-25',
      label: 'Cách mạng hóa quản lý máy móc, thiết bị nặng: Công nghệ đột phá tại hiện trường',
      path: '/vi/blog/heavyEquipment',
    },
    {
      name: 'blogConstructionSafety',
      date: '2023-09-19',
      label: 'Công trường xây dựng an toàn và thông minh hơn nhờ giải pháp RTLS',
      path: '/vi/blog/constructionSafety',
    },
    {
      name: 'blogLogisticsTech',
      date: '2023-09-13',
      label: 'Các xu hướng công nghệ mới nhất mà người trong ngành logistics cần biết',
      path: '/vi/blog/logisticsTech',
    },
    {
      name: 'blogLogisticsAsset',
      date: '2023-09-08',
      label: 'Hiện đại hóa quản lý kho hàng tại trung tâm logistics: Giải pháp dựa trên RTLS',
      path: '/vi/blog/logisticsAsset',
    },
    {
      name: 'blogLogisticsWorker',
      date: '2023-09-06',
      label: 'Cách quản lý an toàn cho người lao động tại cơ sở Smart Logistics',
      path: '/vi/blog/logisticsWorker',
    },
    {
      name: 'blogUwbLogistics',
      date: '2023-09-05',
      label: 'Smart Logistics Center ứng dụng công nghệ UWB',
      path: '/vi/blog/uwbLogistics',
    },
    {
      name: 'blogLogistics',
      date: '2023-09-04',
      label: 'Smart Logistics Center: RTLS - Nhân tố thay đổi cuộc chơi',
      path: '/vi/blog/logistics',
    },
    {
      name: 'blogUwbGeofence',
      date: '2023-09-01',
      label: 'Sự đổi mới của hệ thống Geofence sử dụng công nghệ UWB siêu chính xác',
      path: '/vi/blog/uwbGeofence',
    },
    {
      name: 'blogMedicalWaste',
      date: '2023-08-30',
      label: 'Công nghệ thông minh quản lý chất thải y tế và tài sản',
      path: '/vi/blog/medicalWaste',
    },
    {
      name: 'blogHospital',
      date: '2023-08-21',
      label: 'Cách các bệnh viện tiên tiến quản lý bệnh nhân',
      path: '/vi/blog/hospital',
    },
    {
      name: 'blogVisitor',
      date: '2023-08-14',
      label: 'Nguyên nhân khiến khách tham quan phòng triển lãm của bạn giảm đi',
      path: '/vi/blog/visitor',
    },
    {
      name: 'blogPatientTracking',
      date: '2023-08-07',
      label: 'Hệ thống theo dõi quản lý bệnh nhân thời gian thực',
      path: '/vi/blog/patientTracking',
    },
    {
      name: 'blogSmartLogistics',
      date: '2023-08-03',
      label: 'Lý do Kho logistics thông minh (Smart Logistics Warehouse) đang dẫn đầu ngành',
      path: '/vi/blog/smartLogistics',
    },
    {
      name: 'blogSmartConstruction',
      date: '2023-07-31',
      label: 'Hệ thống quản lý an toàn công trường xây dựng thông minh',
      path: '/vi/blog/smartConstruction',
    },
    {
      name: 'blogOffice',
      date: '2023-06-02',
      label: 'Năm 2023, Cách xây dựng Smart Office',
      path: '/vi/blog/office',
    },
    {
      name: 'blogConsider',
      date: '2023-05-19',
      label: 'Những điều cần cân nhắc khi lựa chọn giải pháp RTLS',
      path: '/vi/blog/consider',
    },
    {
      name: 'blogForklift',
      date: '2023-05-17',
      label: 'Giải pháp RTLS cải thiện an toàn cho người vận hành xe nâng',
      path: '/vi/blog/forklift',
    },
    {
      name: 'blogActiveRfid',
      date: '2023-05-16',
      label: 'RTLS dựa trên công nghệ Active RFID',
      path: '/vi/blog/activerfid',
    },
    {
      name: 'blogManufacture',
      date: '2023-05-14',
      label: 'Cách RTLS và IoT cách mạng hóa hoạt động sản xuất',
      path: '/vi/blog/manufacture',
    },
    {
      name: 'blogAirport',
      date: '2023-05-10',
      label: 'Ứng dụng RTLS tại sân bay',
      path: '/vi/blog/airport',
    },
    {
      name: 'blogMedical',
      date: '2023-05-04',
      label: 'RTLS trong ngành y tế',
      path: '/vi/blog/medical',
    },
    {
      name: 'blogGeofence',
      date: '2023-05-01',
      label: 'Geofence là gì? Geofence hoạt động như thế nào?',
      path: '/vi/blog/geofence',
    },
    {
      name: 'blogUwb',
      date: '2023-04-25',
      label: 'UWB là gì? Những lợi ích cho doanh nghiệp?',
      path: '/vi/blog/uwb',
    },
    {
      name: 'blogDigitalTwin',
      date: '2023-04-22',
      label: 'Digital Twin & Hệ thống định vị thời gian thực',
      path: '/vi/blog/digitalTwin',
    },
    {
      name: 'blogRTLS',
      date: '2023-04-17',
      label: 'Hệ thống định vị thời gian thực (RTLS) là gì?',
      path: '/vi/blog/rtls',
    },
  ],

  back: 'Quay lại Blog ORBRO',
  newletter: 'Đăng ký nhận bản tin',
  info: 'Cập nhật những thông tin mới nhất!',
  placeholder: 'Nhập email của bạn',
  subscribe: 'Đăng ký',
  term1: 'Bằng việc cung cấp thông tin, tôi đồng ý với',
  terms2: 'Chính sách',
  terms3: 'xử lý thông tin cá nhân',
  terms4: 'của ORBRO.',
  more: 'Xem thêm',
  less: 'Thu gọn',

  recent: 'Bài viết mới nhất',
  share: 'Bạn thích bài viết này?<br/>Chia sẻ ngay',
};
